



























import Vue from 'vue-property-decorator';

export default {
    props: {
        title: [],
        fields: [],
        infos: []
    },
    data() {
        return {
        }
    },
    mounted() {
    }
}

